import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  looseThingsData: [],
  looseThingsLoader: true,
  looseThingsError: "",
};

const getEndpoint = (roomName) => {
const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};

export const fetchLooseThingsList = createAsyncThunk(
  'fetchlooseThings',
  async ({  } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('LooseFurniture');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch loose furniture data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const looseFurnitureReducer = createSlice({
  name: 'looseThings',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLooseThingsList.fulfilled]: (state, action) => {
      state.looseThingsData = action.payload;
      state.looseThingsLoader = false;
      state.looseThingsError = "";
    },
    [fetchLooseThingsList.pending]: (state) => {
      state.looseThingsLoader = true;
      state.looseThingsError = "";
    },
    [fetchLooseThingsList.rejected]: (state, action) => {
      state.looseThingsLoader = false;
      state.looseThingsError = action.payload ?? "refresh the page";
    },
  },
});

export default looseFurnitureReducer.reducer;